export function isMobile(): boolean {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}

export function isAndroid(): boolean {
  return /Android/i.test(navigator.userAgent);
}

interface CustomWindow extends Window {
  MSStream: any;
}

export function isIOS(): boolean {
  return /iPad|iPhone|iPod/i.test(navigator.userAgent) && !(window as CustomWindow).MSStream;
}

export function getIOSVersion(): boolean | number {
  if (!isIOS()) return false;

  const OSVersion = getOSVersion();
  const versionRegex = /OS \d+((_\d+))+/g;

  const matches = OSVersion.match(versionRegex);
  const version = matches ? matches[0] : '';
  const normalized = version.replace('OS ', '').replace(/_/g, '.');

  return parseFloat(normalized);
}

export function getAndroidVersion(): boolean | number {
  if (!isAndroid()) return false;

  const OSVersion = getOSVersion();
  const versionRegex = /Android \d+((.\d+))+/g;

  const matches = OSVersion.match(versionRegex);
  const version = matches ? matches[0] : '';
  const normalized = version.replace('Android ', '');

  return parseFloat(normalized);
}

export function getOSVersion(): string {
  const versionRegex = /\(([^)]+)\)/g;
  const matches = navigator.userAgent.match(versionRegex);
  return matches ? matches[0] : '';
}

export default {
  isIOS,
  isMobile,
  isAndroid,
  getIOSVersion,
  getAndroidVersion,
};
